module.exports = __webpack_public_path__ + "img/Feature.5392acf8.jpg";